import React from 'react';

const Blockquote = () => {
  const platformUrl =
    process.env.REACT_APP_SMSE_WORLD_URL;

  return (
    <blockquote>
      <p className="quote">
        Join{' '}
        <a
          href={platformUrl}
          target="_blank"
          rel="noreferrer"
        >
          MSMEs World - GIP 
        </a>{' '}
        platform
      </p>
    </blockquote>
  );
};

export default Blockquote;
